document.addEventListener('DOMContentLoaded', function() {

  // ── Scroll reveal ──
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) e.target.classList.add('visible');
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(function(el) { obs.observe(el); });

  // ── All 50 states + DC: 2026 midterm voter data ──
  // Registration deadlines, early voting windows, and notes.
  // Sources: state SOS offices, vote.org, NCSL
  var stateData = {
    'AL': { name: 'Alabama', regDeadline: 'Oct 19, 2026', earlyVoting: 'No early voting', note: 'Absentee available with excuse' },
    'AK': { name: 'Alaska', regDeadline: 'Oct 4, 2026', earlyVoting: 'Oct 19 – Nov 2', note: 'In-person early & absentee' },
    'AZ': { name: 'Arizona', regDeadline: 'Oct 5, 2026', earlyVoting: 'Oct 7 – Oct 30', note: 'Mail ballots sent automatically to PEVL list' },
    'AR': { name: 'Arkansas', regDeadline: 'Oct 5, 2026', earlyVoting: 'Oct 19 – Nov 2', note: 'Photo ID required' },
    'CA': { name: 'California', regDeadline: 'Oct 19, 2026', earlyVoting: 'Oct 5 – Nov 3', note: 'Same-day registration available' },
    'CO': { name: 'Colorado', regDeadline: 'Oct 26, 2026', earlyVoting: 'Oct 19 – Nov 3', note: 'All-mail ballot state, same-day reg' },
    'CT': { name: 'Connecticut', regDeadline: 'Oct 27, 2026', earlyVoting: 'Oct 19 – Nov 1', note: 'Same-day registration at polls' },
    'DE': { name: 'Delaware', regDeadline: 'Oct 10, 2026', earlyVoting: 'No early voting', note: 'Absentee voting available' },
    'DC': { name: 'Washington, D.C.', regDeadline: 'Oct 13, 2026', earlyVoting: 'Oct 19 – Nov 1', note: 'Same-day registration available' },
    'FL': { name: 'Florida', regDeadline: 'Oct 5, 2026', earlyVoting: 'Oct 24 – Nov 1', note: 'Photo & signature ID required' },
    'GA': { name: 'Georgia', regDeadline: 'Oct 5, 2026', earlyVoting: 'Oct 12 – Oct 30', note: 'Photo ID required' },
    'HI': { name: 'Hawaii', regDeadline: 'Oct 5, 2026', earlyVoting: 'Oct 20 – Nov 3', note: 'All-mail ballot state' },
    'ID': { name: 'Idaho', regDeadline: 'Oct 9, 2026', earlyVoting: 'Varies by county', note: 'Same-day registration at polls' },
    'IL': { name: 'Illinois', regDeadline: 'Oct 6, 2026', earlyVoting: 'Sep 24 – Nov 2', note: 'Same-day registration, grace period voting' },
    'IN': { name: 'Indiana', regDeadline: 'Oct 5, 2026', earlyVoting: 'Oct 6 – Nov 2', note: 'Photo ID required' },
    'IA': { name: 'Iowa', regDeadline: 'Oct 19, 2026', earlyVoting: 'Oct 5 – Nov 2', note: 'Same-day registration at polls' },
    'KS': { name: 'Kansas', regDeadline: 'Oct 13, 2026', earlyVoting: 'Oct 14 – Nov 2', note: 'Advance voting in person' },
    'KY': { name: 'Kentucky', regDeadline: 'Oct 5, 2026', earlyVoting: 'No early voting', note: 'Absentee with excuse, photo ID required' },
    'LA': { name: 'Louisiana', regDeadline: 'Oct 5, 2026', earlyVoting: 'Oct 20 – Oct 27', note: 'Photo ID required' },
    'ME': { name: 'Maine', regDeadline: 'Oct 19, 2026', earlyVoting: 'Varies by municipality', note: 'Same-day registration, ranked choice voting' },
    'MD': { name: 'Maryland', regDeadline: 'Oct 13, 2026', earlyVoting: 'Oct 22 – Oct 29', note: 'Same-day reg during early voting' },
    'MA': { name: 'Massachusetts', regDeadline: 'Oct 14, 2026', earlyVoting: 'Oct 17 – Oct 30', note: 'Mail-in voting available for all' },
    'MI': { name: 'Michigan', regDeadline: 'Oct 19, 2026', earlyVoting: 'Oct 22 – Nov 1', note: 'Same-day registration, photo ID or affidavit' },
    'MN': { name: 'Minnesota', regDeadline: 'Oct 13, 2026', earlyVoting: 'Sep 18 – Nov 2', note: 'Same-day registration at polls' },
    'MS': { name: 'Mississippi', regDeadline: 'Oct 5, 2026', earlyVoting: 'No early voting', note: 'Absentee with excuse, photo ID required' },
    'MO': { name: 'Missouri', regDeadline: 'Oct 7, 2026', earlyVoting: 'No early voting', note: 'Absentee in-person 2 weeks prior' },
    'MT': { name: 'Montana', regDeadline: 'Oct 5, 2026', earlyVoting: 'Varies by county', note: 'Late registration at county office' },
    'NE': { name: 'Nebraska', regDeadline: 'Oct 16, 2026', earlyVoting: 'Oct 5 – Nov 2', note: 'Early voting in person at county office' },
    'NV': { name: 'Nevada', regDeadline: 'Oct 6, 2026', earlyVoting: 'Oct 17 – Oct 30', note: 'Same-day registration, mail ballots to all active voters' },
    'NH': { name: 'New Hampshire', regDeadline: 'Nov 3, 2026', earlyVoting: 'No early voting', note: 'Same-day registration on Election Day' },
    'NJ': { name: 'New Jersey', regDeadline: 'Oct 13, 2026', earlyVoting: 'Oct 23 – Nov 1', note: 'Mail-in ballot by request' },
    'NM': { name: 'New Mexico', regDeadline: 'Oct 6, 2026', earlyVoting: 'Oct 6 – Oct 31', note: 'Same-day registration during early voting' },
    'NY': { name: 'New York', regDeadline: 'Oct 9, 2026', earlyVoting: 'Oct 24 – Nov 1', note: 'Online registration available' },
    'NC': { name: 'North Carolina', regDeadline: 'Oct 9, 2026', earlyVoting: 'Oct 15 – Oct 31', note: 'Same-day reg during early voting, photo ID required' },
    'ND': { name: 'North Dakota', regDeadline: 'No registration required', earlyVoting: 'Varies by county', note: 'No voter registration — just bring valid ID' },
    'OH': { name: 'Ohio', regDeadline: 'Oct 5, 2026', earlyVoting: 'Oct 6 – Nov 2', note: 'Photo ID required' },
    'OK': { name: 'Oklahoma', regDeadline: 'Oct 9, 2026', earlyVoting: 'Oct 29 – Oct 31', note: 'Photo ID required' },
    'OR': { name: 'Oregon', regDeadline: 'Oct 13, 2026', earlyVoting: 'Ballots mailed Oct 14', note: 'All-mail ballot state' },
    'PA': { name: 'Pennsylvania', regDeadline: 'Oct 5, 2026', earlyVoting: 'Mail-in voting available', note: 'No-excuse mail-in ballots' },
    'RI': { name: 'Rhode Island', regDeadline: 'Oct 4, 2026', earlyVoting: 'Oct 14 – Nov 2', note: 'Photo ID required' },
    'SC': { name: 'South Carolina', regDeadline: 'Oct 2, 2026', earlyVoting: 'No early voting', note: 'Absentee in-person & by mail, photo ID required' },
    'SD': { name: 'South Dakota', regDeadline: 'Oct 19, 2026', earlyVoting: 'Absentee in-person available', note: 'Photo ID required' },
    'TN': { name: 'Tennessee', regDeadline: 'Oct 5, 2026', earlyVoting: 'Oct 14 – Oct 29', note: 'Photo ID required' },
    'TX': { name: 'Texas', regDeadline: 'Oct 5, 2026', earlyVoting: 'Oct 19 – Oct 30', note: 'Photo ID required' },
    'UT': { name: 'Utah', regDeadline: 'Oct 23, 2026', earlyVoting: 'Ballots mailed Oct 13', note: 'All-mail ballot state, same-day reg' },
    'VT': { name: 'Vermont', regDeadline: 'Nov 3, 2026', earlyVoting: 'Ballots mailed Sep 2026', note: 'Same-day registration on Election Day' },
    'VA': { name: 'Virginia', regDeadline: 'Oct 13, 2026', earlyVoting: 'Sep 18 – Oct 31', note: 'Photo ID required, free ID available' },
    'WA': { name: 'Washington', regDeadline: 'Oct 26, 2026', earlyVoting: 'Ballots mailed Oct 15', note: 'All-mail ballot state, same-day reg' },
    'WV': { name: 'West Virginia', regDeadline: 'Oct 13, 2026', earlyVoting: 'Oct 21 – Oct 31', note: 'Photo ID required' },
    'WI': { name: 'Wisconsin', regDeadline: 'Oct 14, 2026', earlyVoting: 'Oct 20 – Nov 1', note: 'Same-day registration at polls, photo ID required' },
    'WY': { name: 'Wyoming', regDeadline: 'Oct 19, 2026', earlyVoting: 'Absentee in-person available', note: 'Same-day registration on Election Day' }
  };

  // ── Zip prefix to state code mapping (first 3 digits) ──
  var zipToState = {};
  function addRange(start, end, st) { for (var i = start; i <= end; i++) { zipToState[String(i).padStart(3, '0')] = st; } }
  // Source: USPS zip code prefix assignments
  addRange(35, 36, 'AL'); addRange(995, 999, 'AK'); addRange(85, 86, 'AZ'); addRange(716, 729, 'AR');
  addRange(900, 961, 'CA'); addRange(800, 816, 'CO'); addRange(60, 69, 'CT'); addRange(197, 199, 'DE');
  addRange(200, 205, 'DC'); addRange(320, 349, 'FL'); addRange(300, 319, 'GA'); addRange(967, 968, 'HI');
  addRange(832, 838, 'ID'); addRange(600, 629, 'IL'); addRange(460, 479, 'IN'); addRange(500, 528, 'IA');
  addRange(660, 679, 'KS'); addRange(400, 427, 'KY'); addRange(700, 714, 'LA'); addRange(39, 49, 'ME');
  addRange(206, 219, 'MD'); addRange(10, 27, 'MA'); addRange(480, 499, 'MI'); addRange(550, 567, 'MN');
  addRange(386, 397, 'MS'); addRange(630, 658, 'MO'); addRange(590, 599, 'MT'); addRange(680, 693, 'NE');
  addRange(889, 898, 'NV'); addRange(30, 38, 'NH'); addRange(70, 89, 'NJ'); addRange(870, 884, 'NM');
  addRange(100, 149, 'NY'); addRange(270, 289, 'NC'); addRange(580, 588, 'ND'); addRange(430, 459, 'OH');
  addRange(730, 749, 'OK'); addRange(970, 979, 'OR'); addRange(150, 196, 'PA'); addRange(28, 29, 'RI');
  addRange(290, 299, 'SC'); addRange(570, 577, 'SD'); addRange(370, 385, 'TN'); addRange(750, 799, 'TX');
  addRange(840, 847, 'UT'); addRange(50, 59, 'VT'); addRange(220, 246, 'VA'); addRange(980, 994, 'WA');
  addRange(247, 268, 'WV'); addRange(530, 549, 'WI'); addRange(820, 831, 'WY');
  // Additional overrides
  zipToState['006'] = 'PR'; zipToState['007'] = 'PR'; zipToState['008'] = 'PR'; zipToState['009'] = 'PR';
  zipToState['340'] = 'AA'; // Military
  zipToState['962'] = 'AP'; // Military Pacific
  // MA includes 01-05 as well
  addRange(1, 5, 'MA');

  function getStateFromZip(zip) {
    var prefix = zip.substring(0, 3);
    return zipToState[prefix] || null;
  }

  // ── Show state info ──
  function showState(zip) {
    var stateCode = getStateFromZip(zip);
    var data = stateCode ? stateData[stateCode] : null;

    var stateNameEl = document.getElementById('state-name');
    var stateSection = document.getElementById('register');
    var stateCard = document.getElementById('state-card');
    var stateFallback = document.getElementById('state-fallback');
    var regEl = document.getElementById('sd-reg-deadline');
    var earlyEl = document.getElementById('sd-early-voting');
    var electionEl = document.getElementById('sd-election-day');

    if (data) {
      if (stateNameEl) stateNameEl.textContent = data.name + ' Voter Info';
      if (regEl) regEl.textContent = data.regDeadline;
      if (earlyEl) earlyEl.textContent = data.earlyVoting;
      if (electionEl) electionEl.textContent = data.note;
      if (stateCard) stateCard.classList.add('active');
      if (stateSection) stateSection.classList.add('active');
      if (stateFallback) stateFallback.style.display = 'none';
    } else {
      // Unknown zip, still show card with generic info
      if (stateNameEl) stateNameEl.textContent = 'Voter Info';
      if (regEl) regEl.textContent = 'Check your state';
      if (earlyEl) earlyEl.textContent = 'Varies by state';
      if (electionEl) electionEl.textContent = 'Nov 3, 2026';
      if (stateCard) stateCard.classList.add('active');
      if (stateSection) stateSection.classList.add('active');
      if (stateFallback) stateFallback.style.display = 'none';
    }
  }

  // ── Hero zip ──
  var heroBtn = document.getElementById('zip-hero-btn');
  var heroInput = document.getElementById('zip-hero');
  if (heroBtn && heroInput) {
    heroBtn.addEventListener('click', function() {
      var z = heroInput.value.replace(/\D/g, '');
      if (z.length === 5) {
        showState(z);
        var reg = document.getElementById('register');
        if (reg) reg.scrollIntoView({ behavior: 'smooth' });
      }
    });
    heroInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') heroBtn.click();
    });
  }

  // ── Fallback zip ──
  var fbBtn = document.getElementById('zip-fb-btn');
  var fbInput = document.getElementById('zip-fb');
  if (fbBtn && fbInput) {
    fbBtn.addEventListener('click', function() {
      var z = fbInput.value.replace(/\D/g, '');
      if (z.length === 5) showState(z);
    });
    fbInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') fbBtn.click();
    });
  }

  // ── Change zip ──
  var changeZip = document.getElementById('change-zip');
  if (changeZip) {
    changeZip.addEventListener('click', function() {
      var stateCard = document.getElementById('state-card');
      var stateSection = document.getElementById('register');
      var stateFallback = document.getElementById('state-fallback');
      if (stateCard) stateCard.classList.remove('active');
      if (stateSection) stateSection.classList.remove('active');
      if (stateFallback) stateFallback.style.display = 'block';
      // Close any open embeds
      closeAllEmbeds();
    });
  }

  // ── Embed toggle system ──
  // Finds the nearest embed container and toggles the requested panel
  function closeAllEmbeds() {
    document.querySelectorAll('.embed-panel').forEach(function(panel) {
      panel.style.display = 'none';
    });
    document.querySelectorAll('[data-embed-toggle]').forEach(function(btn) {
      btn.classList.remove('active');
    });
  }

  function toggleEmbed(button, type) {
    // Determine which container to target
    var targetAttr = button.getAttribute('data-embed-target');
    var containerId;
    if (targetAttr === 'state') {
      containerId = 'state-embed-' + type;
    } else {
      containerId = 'hero-embed-' + type;
    }

    var panel = document.getElementById(containerId);
    if (!panel) return;

    var isVisible = panel.style.display !== 'none';

    // Close all panels first
    closeAllEmbeds();

    // If it wasn't visible, open it
    if (!isVisible) {
      panel.style.display = 'block';
      button.classList.add('active');
      // Smooth scroll to the panel
      setTimeout(function() {
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 50);
    }
  }

  // Bind toggle buttons
  document.querySelectorAll('[data-embed-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var type = this.getAttribute('data-embed-toggle');
      toggleEmbed(this, type);
    });
  });

  // Bind close buttons
  document.querySelectorAll('[data-embed-close]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      closeAllEmbeds();
    });
  });

  // ── Location notice ──
  var locNotice = document.getElementById('loc-notice');
  if (locNotice) {
    var allowBtn = locNotice.querySelector('.loc-btn.yes');
    var denyBtn = locNotice.querySelector('.loc-btn.no');
    if (allowBtn) {
      allowBtn.addEventListener('click', function() {
        locNotice.classList.add('hidden');
      });
    }
    if (denyBtn) {
      denyBtn.addEventListener('click', function() {
        locNotice.classList.add('hidden');
        if (heroInput) {
          heroInput.focus();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    }
  }

  // ── Quantity selector ──
  document.querySelectorAll('.quantity-selector').forEach(function(sel) {
    var input = sel.querySelector('input');
    var minus = sel.querySelector('.qty-minus');
    var plus = sel.querySelector('.qty-plus');
    if (minus && input) {
      minus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
    }
    if (plus && input) {
      plus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    }
  });

  // ── Mobile hamburger menu ──
  var hamburger = document.querySelector('.nav-hamburger');
  var nav = document.querySelector('.nav');
  if (hamburger && nav) {
    hamburger.addEventListener('click', function(e) {
      e.stopPropagation();
      nav.classList.toggle('nav-open');
    });
    // Close menu when a link is clicked
    nav.querySelectorAll('.nav-links a').forEach(function(link) {
      link.addEventListener('click', function() {
        nav.classList.remove('nav-open');
      });
    });
    // Close when clicking outside
    document.addEventListener('click', function(e) {
      if (nav.classList.contains('nav-open') && !nav.contains(e.target)) {
        nav.classList.remove('nav-open');
      }
    });
  }

  // ── iFrame Resizer (for vote.org embeds) ──
  var iframeScript = document.createElement('script');
  iframeScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.3/iframeResizer.min.js';
  iframeScript.onload = function() {
    if (window.iFrameResize) {
      iFrameResize({ log: false, checkOrigin: false });
    }
  };
  document.head.appendChild(iframeScript);
});
